

  export const helloTriangle = async () => (await import('../src/examples/helloTriangle'));
  

  export const simulation = async () => (await import('../src/examples/simulation'));
  

  export const amongUs = async () => (await import('../src/examples/amongUs'));
  

  export const pikachu = async () => (await import('../src/examples/pikachu'));
  

  export const turkey = async () => (await import('../src/examples/turkey'));
  

  export const twoHearts = async () => (await import('../src/examples/twoHearts'));
  

  export const dogTurkeyHeart = async () => (await import('../src/examples/dogTurkeyHeart'));
  

  export const twoFluids = async () => (await import('../src/examples/twoFluids'));
  
